import { useState } from "react";

export type FormState = "IDLE" | "LOADING" | "ERROR" | "SUCCESS";

export type FormStatus = {
  state: FormState;
  message?: string;
};

export function useFormState(initial?: FormStatus) {
  return useState<FormStatus>(initial || { state: "IDLE" });
}
